import type { SetPasswordLinkError as SetPasswordLinkErrorType } from '@/scopes/auth/domain/types'
import { Button } from '@sunwebgroup/uds-ui/button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useSetPasswordActions } from '@/scopes/auth/infrastructure/setPasswordDependencies'
import { AuthConfirmationLayout } from '../AuthConfirmationLayout'
import styles from './SetPasswordMessage.module.css'

const SET_PASSWORD_LINK_ERROR_HEADING_KEY: Record<SetPasswordLinkErrorType, string> = {
  expired: 'auth_set_password_link_expired_heading',
  validationFailed: 'auth_set_password_link_validation_failed_heading',
}

const SET_PASSWORD_LINK_ERROR_MESSAGE_KEY: Record<SetPasswordLinkErrorType, string> = {
  expired: 'auth_set_password_link_expired_message',
  validationFailed: 'auth_set_password_link_validation_failed_message',
}

export interface SetPasswordLinkErrorProps {
  type: SetPasswordLinkErrorType
}

export function SetPasswordLinkError({ type }: SetPasswordLinkErrorProps) {
  const intl = useIntl()
  const { loginPageRequested } = useSetPasswordActions()

  return (
    <AuthConfirmationLayout
      icon="ExclamationInCircle"
      title={intl.formatMessage({ id: SET_PASSWORD_LINK_ERROR_HEADING_KEY[type] })}
      showSpamNote={false}
      role="alert"
    >
      <Typography as="p" variant="body-m-regular-snug" className={styles.message}>
        {intl.formatMessage({ id: SET_PASSWORD_LINK_ERROR_MESSAGE_KEY[type] })}
      </Typography>
      <Button type="button" variant="primary" fullWidth onClick={loginPageRequested}>
        {intl.formatMessage({ id: 'auth_set_password_sign_in_label' })}
      </Button>
    </AuthConfirmationLayout>
  )
}
